import prepareComponent from "@bluframe/grapple/prepareComponent";
import useActionsCheckbox from "hooks/actions/useActionsCheckbox";
import useClearHomeVideoReviewsListButton from "hooks/actions/useClearHomeVideoReviewsListButton";
import useListButton from "hooks/actions/useListButton";
import { memo } from "react";
import Actions from "./Actions";
const usePrepareComponent = ({ isAdmin, isEditor, serviceName }) => {
    const onlyNewProps = useActionsCheckbox({
        inputId: `${serviceName}-isOnlyNew`,
        label: "Only New",
        serviceName,
        serviceType: "reviews",
        setValueName: "setIsOnlyNew",
        valueName: "isOnlyNew"
    });
    const onlyPresentProps = useActionsCheckbox({
        inputId: `${serviceName}-isOnlyPresent`,
        label: "Only Present",
        serviceName,
        serviceType: "reviews",
        setValueName: "setIsOnlyPresent",
        valueName: "isOnlyPresent"
    });
    const showFlaggedProps = useActionsCheckbox({
        inputId: `${serviceName}-isShowFlagged`,
        label: "Show Flagged",
        serviceName,
        serviceType: "reviews",
        setValueName: "setIsShowFlagged",
        valueName: "isShowFlagged"
    });
    const listButtonProps = useListButton({
        serviceName,
        serviceType: "reviews"
    });
    const clearListButtonProps = useClearHomeVideoReviewsListButton({
        isLoading: listButtonProps.loading,
        serviceName
    });
    return {
        clearListButtonProps,
        isAdmin,
        isEditor,
        listButtonProps,
        onlyNewProps,
        onlyPresentProps,
        serviceName,
        showFlaggedProps
    };
};
export default prepareComponent(usePrepareComponent)(memo(Actions));
